const GlowingBorder = () => {
  return (
    <>
      {/* Glow Effect */}
      <div
        className="rounded-2 pointer-events-none absolute inset-0 -z-10"
        style={{
          opacity: 0.24,
          background:
            'linear-gradient(134deg, #7E77B3 0%, #8989FF 25%, #6C9DFF 50%, #78CFDA 75%, #9FF4A9 100%)',
          filter: 'blur(16px)',
        }}
      />

      {/* Gradient Border */}
      <div
        className="pointer-events-none absolute inset-0 rounded-[4px] p-[2px]"
        style={{
          background:
            'linear-gradient(134deg, #7E77B3, #8989FF, #6C9DFF, #78CFDA, #9FF4A9)',
          WebkitMask:
            'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
        }}
      />
    </>
  );
};

export default GlowingBorder;
